module.exports = __webpack_public_path__ + "img/130ne.026750c5.svg";